import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useContext, useState, useId } from 'react';
import { useQueryGtfsResourceById } from '../../Queries';
import { ToolsContext, ToolsDispatchContext } from '../../ToolsContext';
import React from 'react';
import { PropertyEditor } from '../../window/PropertyEditor';
import { SnapshotContext } from '../../SnapshotContext';
import { DataContext } from '../../DataContext';
import { OverlayContext } from "../../OverlaysContext";
import { queryClient, useMutateGtfsResource, useQueryGtfsResource, useDeleteGtfsResource } from "../../Queries";
import { PropertyInput } from '../../components/PropertyInput';
import { PropertyDropdown } from '../../components/PropertyDropdown';
import React from 'react';
import { RouteName } from '../../components/RouteName';
import { RouteTypeIndicator } from '../../components/RouteTypeIndicator';
import { AccessibilityPropertyCheckbox } from '../../components/AccessibilityPropertyCheckbox';
import React from 'react';
import { PropertySelectButton } from '../../components/PropertySelectButton';
import { TripsStopTimesEditor } from './TripsStopTimesEditor';

export function TripPropertyEditor({ GTrip }) {
    const header = (
        <>
            Kurs nr {GTrip.trip_id} {(GTrip.trip_short_name) ? <> — {GTrip.trip_short_name}</> : <></>}
        </>
    )

    return (
        <PropertyEditor resourceTable='trips' selectedItemId={GTrip.trip_id} header={header}  >
            <TripPropertiesForm></TripPropertiesForm>
        </PropertyEditor>
    )
}

function TripPropertiesForm() {
    const id = useId();
    const snap = useContext(SnapshotContext);
    const modifyTrip = useMutateGtfsResource();
    const data = useContext(DataContext);
    const handleOverlays = useContext(OverlayContext);
    const tool = useContext(ToolsContext);
    const [modifiedValues, setModifiedValues] = useState(data.inputValues);
    const [validationErrors, setValidationErrors] = useState(false);
    const [isMutationPending, setIsMutationPending] = useState(false);
    const { data: routes } = useQueryGtfsResource('routes');
    const { data: calendars } = useQueryGtfsResource('calendars');

    function handleClickDelete() {

    }

    function handleInput(propertyName,value) {
        let newValues = {...modifiedValues};
        newValues[propertyName] = value;
        setModifiedValues(newValues);
    }

    async function handleInputDone(propertyName, value) {
        if(value === data.inputValues[propertyName]) {
            return; // Nie wysyłamy zmian na serwer, jeżeli nowa wartość jest taka jak już zapisana do serwera.
        }

        const payload = {
            query: {
              modified_id: String(data.inputValues.trip_id),
              resourceTable: 'trips'
            },
            fields: {}
          };
          payload.fields[propertyName] = value;
          console.log('payload',payload)
          setIsMutationPending(true);

          try {
            const asyncMutation = await modifyTrip.mutateAsync(payload);  // próbujemy przeprowadzić mutację

            // wykasuj ewentualne istniejące błędy walidacji z UI, skoro wszystko poszło ok
            if(validationErrors[propertyName]) {
                let updatedValidationErrors = {...validationErrors};
                updatedValidationErrors[propertyName] = false;
                setValidationErrors({
                    ...updatedValidationErrors
                });                   
            }
        } catch(error) {
            const errorCode = error.message.slice(0,3);
            if(errorCode == '422') {
                //obsługa błędów walidacji
                let updatedValidationErrors = {...validationErrors};
                updatedValidationErrors[propertyName] = Object.values(error.cause.validation[propertyName]).join(', ');
                setValidationErrors({
                    ...updatedValidationErrors
                });
            } else {
                //obsługa pozostałych błędów
                handleOverlays('toast',{
                    severity: "error",
                    summary: 'Błąd ' + errorCode,
                    detail: (typeof error.cause === 'undefined' || typeof error.cause.message === 'undefined') ? 'Wystąpił błąd. Czynność nie mogła zostać zakończona powodzeniem. ' + error.message : error.cause.message
                });
                console.log(error);
            }

        } finally {
            setIsMutationPending(false);
        }

    }

    function handleInputCancel() {
        setModifiedValues(data.inputValues);
    }

    const routesOptions = (routes) ? Object.values(routes) : [];
    const calendarsOptions = (calendars) ? Object.values(calendars) : [];

    const routeOptionTemplate = (option) => {
        const item = option;
        return (
            <div className="flex align-items-center">
                <RouteTypeIndicator GRoute={item} />
                {(item.route_short_name) ? <RouteName GRoute={item} /> : <></>}
                <div className="text-sm">
                    {(item.route_short_name) ? <b>{item.route_long_name}</b> : <b className='hover:text-orange-700' style={{ display: "inline-block", fontWeight: "normal", backgroundColor: '#' + item.route_color, color: '#' + item.route_text_color, borderStyle: 'solid', borderWidth: '0.5pt', padding: '2px', borderColor: '#' + item.route_text_color }}>{item.route_long_name}</b>}
                    {(item.suspended) ? <span className="text-red-200"> zawieszona </span> : <></>}
                    <br />
                    <span className="text-200">{item.network_id}</span>
                </div>
            </div>
        )
    }


    const routeSelectedTemplate = (option, props) => {
        if (option) {
            const item = option;
            return (
                <div className="flex align-items-center">
                    <RouteTypeIndicator GRoute={item} />
                    {(item.route_short_name) ? <RouteName GRoute={item} /> : <></>}
                    <div className="text-sm">
                        {(item.route_short_name) ? <b>{item.route_long_name}</b> : <b className='hover:text-orange-700' style={{ display: "inline-block", fontWeight: "normal", backgroundColor: '#' + item.route_color, color: '#' + item.route_text_color, borderStyle: 'solid', borderWidth: '0.5pt', padding: '2px', borderColor: '#' + item.route_text_color }}>{item.route_long_name}</b>}
                        {(item.suspended) ? <span className="text-red-200"> zawieszona </span> : <></>}
                        <br />
                        <span className="text-200">{item.network_id}</span>
                    </div>
                </div>
            )
        } else {
            return <span>{props.placeholder}</span>
        }

    }

    return (
        <>
            <div className="formgrid grid">
                <div className="field col-6">
                    <PropertyInput
                        propertyName='trip_id'
                        label="Numer kursu"
                        id={id}
                        value={modifiedValues.trip_id}
                        initialVal={data.inputValues.trip_id}
                        onDone={handleInputDone}
                        onChange={handleInput}
                        onCancel={handleInputCancel}
                        /* invalid={validationErrors.stop_id} */
                        disabled={false}
                        pending={isMutationPending}
                    />
                </div>
                <div className="field col-6">
                    <PropertyInput
                        propertyName='trip_short_name'
                        label="Publiczny numer kursu"
                        id={id}
                        value={modifiedValues.trip_short_name}
                        initialVal={data.inputValues.trip_short_name}
                        onDone={handleInputDone}
                        onChange={handleInput}
                        onCancel={handleInputCancel}
                        /* invalid={validationErrors.stop_id} */
                        disabled={false}
                        pending={isMutationPending}
                    />
                </div>
                <div className='field col-12'>
                    <PropertyDropdown
                        propertyName='route_id'
                        initialVal={data.inputValues.route_id}
                        label="Należy do linii:"
                        options={routesOptions}
                        onDone={handleInputDone}
                        itemTemplate={routeOptionTemplate}
                        valueTemplate={routeSelectedTemplate}
                        optionValue='route_id'
                        filter={true}
                        filterBy='route_id,route_short_name,route_long_name'
                        filterInputAutoFocus={true}
                    />
                </div>
                <div className="field col-12">
                    <PropertyInput
                        propertyName='trip_headsign'
                        label="Tablica kierunkowa:"
                        id={id}
                        value={modifiedValues.trip_headsign}
                        initialVal={data.inputValues.trip_headsign}
                        onDone={handleInputDone}
                        onChange={handleInput}
                        onCancel={handleInputCancel}
                        /* invalid={validationErrors.stop_id} */
                        disabled={false}
                        pending={isMutationPending}
                    />
                </div>
                <div className="field col-6">
                    <PropertySelectButton
                        id={id}
                        propertyName='direction_id'
                        initialVal={data.inputValues.direction_id}
                        label='Kierunek jazdy:'
                        options={[
                            { label: 'TAM', value: 0 },
                            { label: 'POWRÓT', value: 1 }
                        ]}
                        optionValue='value'
                    />
                </div>
                <div className="field col-6">
                    <PropertyInput
                        propertyName='block_id'
                        label="Nr brygady"
                        id={id}
                        value={modifiedValues.block_id}
                        initialVal={data.inputValues.block_id}
                        onDone={handleInputDone}
                        onChange={handleInput}
                        onCancel={handleInputCancel}
                        /* invalid={validationErrors.stop_id} */
                        disabled={false}
                        pending={isMutationPending}
                    />
                </div>
                <div className='field col-12'>
                    <PropertyDropdown
                        propertyName='service_id'
                        initialVal={data.inputValues.service_id}
                        label="Kursuje według kalendarza:"
                        options={calendarsOptions}
                        onDone={handleInputDone}
                        itemTemplate={(option) => <div>{option.service_id} – {option.service_description}</div>}
                        valueTemplate={(option, props) => {
                            if (option)
                                return <div>{option.service_id} – {option.service_description}</div>
                            else
                                return <div>{props.placeholder}</div>
                        }
                        }
                        optionValue='service_id'
                        optionLabel='service_description'
                        filter={true}
                        filterBy='service_id'
                        filterInputAutoFocus={true}
                    />
                </div>
                <div className="field col-12">
                    <PropertySelectButton
                        id={id}
                        propertyName='wheelchair_accessible'
                        initialVal={data.inputValues.wheelchair_accessible}
                        label='Dostępność dla wózków:'
                        options={[
                            { label: 'Brak info', value: 0 },
                            { label: 'Dostępny', value: 1 },
                            { label: 'Niedostępny', value: 2 }
                        ]}
                        optionValue='value'
                        onDone={handleInputDone}
                    />
                </div>
                <div className="field col-12">
                    <PropertySelectButton
                        id={id}
                        propertyName='bikes_allowed'
                        initialVal={data.inputValues.bikes_allowed}
                        label='Przewóz rowerów:'
                        options={[
                            { label: 'Brak info', value: 0 },
                            { label: 'Możliwy', value: 1 },
                            { label: 'Niemożliwy', value: 2 }
                        ]}
                        optionValue='value'
                        onDone={handleInputDone}
                    />
                </div>
            </div>
            <h3 className='mt-3'>Trasa kursu</h3>
            <TripsStopTimesEditor key={tool.propertyEditor.edit.trip_id} tripId={tool.propertyEditor.edit.trip_id} />
        </>
    )
}